import React, { FC, memo } from "react";
import DownloadBtn from "@components/DownloadBtn/DownloadBtn";
import Modal from "@components/Modal/Modal";
import { IconClose } from "@icons";
import Icon from "@components/Icon/Icon";
import { MenuExampleTable } from "@vms/MenuExampleTable";
import { MenuItemExample } from "@apiHooks/useMenuExamplesPopupData";
import { Sort } from "@models";

interface MenuExamplesPopupProps {
    isShown: boolean;
    close: () => void;
    download: () => void;
    tableData: MenuItemExample[];
    isLoading: boolean;
    totalCountExamples: number;
    getMenuExamples: () => void;
    sort: { direction: Sort.Asc | Sort.Desc; column: number };
    handleSortColumn: (columnIndex: number) => void;
    searchQuery: string;
    handleChangeSearchQuery: (value: string) => void;
}

const MenuExamplesPopup: FC<MenuExamplesPopupProps> = ({
    isShown,
    close,
    download,
    tableData,
    isLoading,
    totalCountExamples,
    getMenuExamples,
    sort,
    handleSortColumn,
    searchQuery,
    handleChangeSearchQuery,
}) => {
    return (
        <Modal shown={isShown} hasOverlay closeModal={close} closeOnOutsideClick>
            <div className="MenuExamplesPopup">
                <div className="MenuExamplesPopup__actions">
                    <div className="MenuExamplesPopup__search">
                        <input
                            className="MenuExamplesPopup__input"
                            type="text"
                            value={searchQuery}
                            onChange={e => handleChangeSearchQuery(e.target.value)}
                            placeholder="Find a term"
                            autoFocus
                        />

                        {searchQuery && (
                            <Icon type="small" className="MenuExamplesPopup__close-icon">
                                <IconClose
                                    onClick={() => handleChangeSearchQuery("")}
                                />
                            </Icon>
                        )}
                    </div>

                    <div className="MenuExamplesPopup__download">
                        <DownloadBtn onClick={download} />
                    </div>
                </div>

                <div className="MenuExamplesPopup__content">
                    <div className="MenuExamplesPopup__table" style={{ height: '100%' }}>
                        <MenuExampleTable
                            data={tableData}
                            isLoading={isLoading}
                            totalCount={totalCountExamples}
                            onLoadMore={getMenuExamples}
                            sortColumn={sort.column}
                            sortDirection={sort.direction}
                            onSortChange={handleSortColumn}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default memo(MenuExamplesPopup);
